/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { BacklinkCountsResponse } from '../models/backlinkCountsResponse';

import type { BacklinkRowCollection } from '../models/backlinkRowCollection';

import type { BulkEntityLinkRequest } from '../models/bulkEntityLinkRequest';

import type { BulkEntityLinkResult } from '../models/bulkEntityLinkResult';

import type { EnrichmentValuesRequest } from '../models/enrichmentValuesRequest';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetParams } from '../models/listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetParams';

import type { PickerEnrichmentColumnsResponse } from '../models/pickerEnrichmentColumnsResponse';

import type { PickerEnrichmentValuesResponse } from '../models/pickerEnrichmentValuesResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Every reachable provider's badge for one subject.

One batched call per provider, so this costs the same whether it is asked for
one subject or fifty.

**Two silences, one shape.** A provider that raised is absent from the
response, and so is one that answered ``None`` for this subject — the first
is fail-soft, the second is a facet gated at a tier this caller does not
hold. Neither is reported as ``0``, because a zero would read as "no deals",
which the caller cannot distinguish from the truth. A subject id simply
MISSING from a provider's mapping is the ordinary empty case and is reported
as ``0``; that is the distinction ``BacklinkCountFn`` documents.
 * @summary Get Related Counts
 */
export const getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet =
  (subjectType: string, subjectId: string, signal?: AbortSignal) => {
    return customInstance<BacklinkCountsResponse>({
      url: `/api/v1/entity-links/${subjectType}/${subjectId}/related-counts`,
      method: 'GET',
      signal
    });
  };

export const getGetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGetQueryKey =
  (subjectType?: string, subjectId?: string) => {
    return [
      `/api/v1/entity-links/${subjectType}/${subjectId}/related-counts`
    ] as const;
  };

export const getGetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
      >
    >,
    TError = HTTPValidationError
  >(
    subjectType: string,
    subjectId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGetQueryKey(
        subjectType,
        subjectId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
        >
      >
    > = ({ signal }) =>
      getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet(
        subjectType,
        subjectId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(subjectType && subjectId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
      >
    >
  >;
export type GetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGetQueryError =
  HTTPValidationError;

export function useGetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet<
  TData = Awaited<
    ReturnType<
      typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  subjectId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet<
  TData = Awaited<
    ReturnType<
      typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  subjectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet<
  TData = Awaited<
    ReturnType<
      typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  subjectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Related Counts
 */

export function useGetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet<
  TData = Awaited<
    ReturnType<
      typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  subjectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetRelatedCountsApiV1EntityLinksSubjectTypeSubjectIdRelatedCountsGetQueryOptions(
      subjectType,
      subjectId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * One page of one provider's inbound references to one subject.

``total`` is post-filter and pre-pagination — the provider filters, then
paginates, so the page is never short and the total is never a lie.
 * @summary List Related
 */
export const listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet =
  (
    subjectType: string,
    subjectId: string,
    providerKey: string,
    params?: ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<BacklinkRowCollection>({
      url: `/api/v1/entity-links/${subjectType}/${subjectId}/related/${providerKey}`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetQueryKey =
  (
    subjectType?: string,
    subjectId?: string,
    providerKey?: string,
    params?: ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetParams
  ) => {
    return [
      `/api/v1/entity-links/${subjectType}/${subjectId}/related/${providerKey}`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
      >
    >,
    TError = HTTPValidationError
  >(
    subjectType: string,
    subjectId: string,
    providerKey: string,
    params?: ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetQueryKey(
        subjectType,
        subjectId,
        providerKey,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
        >
      >
    > = ({ signal }) =>
      listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet(
        subjectType,
        subjectId,
        providerKey,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(subjectType && subjectId && providerKey),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
      >
    >
  >;
export type ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetQueryError =
  HTTPValidationError;

export function useListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet<
  TData = Awaited<
    ReturnType<
      typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  subjectId: string,
  providerKey: string,
  params:
    | undefined
    | ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet<
  TData = Awaited<
    ReturnType<
      typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  subjectId: string,
  providerKey: string,
  params?: ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet<
  TData = Awaited<
    ReturnType<
      typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  subjectId: string,
  providerKey: string,
  params?: ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Related
 */

export function useListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet<
  TData = Awaited<
    ReturnType<
      typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  subjectId: string,
  providerKey: string,
  params?: ListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListRelatedApiV1EntityLinksSubjectTypeSubjectIdRelatedProviderKeyGetQueryOptions(
      subjectType,
      subjectId,
      providerKey,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attach or detach one target across a selection, in bounded set-based writes.

The full rationale for the gate ordering, the two scopes and the absent count
is in this module's docstring; what follows is only what the code does.
 * @summary Bulk Entity Link
 */
export const bulkEntityLinkApiV1EntityLinksBulkPost = (
  bulkEntityLinkRequest: BulkEntityLinkRequest,
  signal?: AbortSignal
) => {
  return customInstance<BulkEntityLinkResult>({
    url: `/api/v1/entity-links/bulk`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkEntityLinkRequest,
    signal
  });
};

export const getBulkEntityLinkApiV1EntityLinksBulkPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkEntityLinkApiV1EntityLinksBulkPost>>,
    TError,
    { data: BulkEntityLinkRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkEntityLinkApiV1EntityLinksBulkPost>>,
  TError,
  { data: BulkEntityLinkRequest },
  TContext
> => {
  const mutationKey = ['bulkEntityLinkApiV1EntityLinksBulkPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkEntityLinkApiV1EntityLinksBulkPost>>,
    { data: BulkEntityLinkRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkEntityLinkApiV1EntityLinksBulkPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkEntityLinkApiV1EntityLinksBulkPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkEntityLinkApiV1EntityLinksBulkPost>>
>;
export type BulkEntityLinkApiV1EntityLinksBulkPostMutationBody =
  BulkEntityLinkRequest;
export type BulkEntityLinkApiV1EntityLinksBulkPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Entity Link
 */
export const useBulkEntityLinkApiV1EntityLinksBulkPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkEntityLinkApiV1EntityLinksBulkPost>>,
      TError,
      { data: BulkEntityLinkRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof bulkEntityLinkApiV1EntityLinksBulkPost>>,
  TError,
  { data: BulkEntityLinkRequest },
  TContext
> => {
  const mutationOptions =
    getBulkEntityLinkApiV1EntityLinksBulkPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Every enrichment column contributed to this subject that the caller can reach.

Answered once when the picker opens. Costs no provider query at all — a
descriptor read — which is why the picker can draw its full header and filter
bar before any row has loaded.
 * @summary List Enrichment Columns
 */
export const listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet =
  (subjectType: string, signal?: AbortSignal) => {
    return customInstance<PickerEnrichmentColumnsResponse>({
      url: `/api/v1/entity-links/picker-enrichment/${subjectType}/columns`,
      method: 'GET',
      signal
    });
  };

export const getListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGetQueryKey =
  (subjectType?: string) => {
    return [
      `/api/v1/entity-links/picker-enrichment/${subjectType}/columns`
    ] as const;
  };

export const getListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
      >
    >,
    TError = HTTPValidationError
  >(
    subjectType: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGetQueryKey(
        subjectType
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
        >
      >
    > = ({ signal }) =>
      listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet(
        subjectType,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!subjectType,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
      >
    >
  >;
export type ListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGetQueryError =
  HTTPValidationError;

export function useListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet<
  TData = Awaited<
    ReturnType<
      typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet<
  TData = Awaited<
    ReturnType<
      typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet<
  TData = Awaited<
    ReturnType<
      typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Enrichment Columns
 */

export function useListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet<
  TData = Awaited<
    ReturnType<
      typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
    >
  >,
  TError = HTTPValidationError
>(
  subjectType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListEnrichmentColumnsApiV1EntityLinksPickerEnrichmentSubjectTypeColumnsGetQueryOptions(
      subjectType,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Contributed cell values for one page of picker rows.

One batched call per provider for the whole page, never one per row.

Absence is the answer for three different situations, deliberately spelled the
same way: an id the caller may not view, an id the provider knows nothing
about, and a provider that raised. All three render as an em dash. The
alternative — a zero — is a claim, and "0 in stock" is a damaging one: it
stops an order the tenant could have filled.
 * @summary Get Enrichment Values
 */
export const getEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost =
  (
    subjectType: string,
    enrichmentValuesRequest: EnrichmentValuesRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<PickerEnrichmentValuesResponse>({
      url: `/api/v1/entity-links/picker-enrichment/${subjectType}/values`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: enrichmentValuesRequest,
      signal
    });
  };

export const getGetEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost
        >
      >,
      TError,
      { subjectType: string; data: EnrichmentValuesRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof getEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost
      >
    >,
    TError,
    { subjectType: string; data: EnrichmentValuesRequest },
    TContext
  > => {
    const mutationKey = [
      'getEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost
        >
      >,
      { subjectType: string; data: EnrichmentValuesRequest }
    > = (props) => {
      const { subjectType, data } = props ?? {};

      return getEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost(
        subjectType,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GetEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost
      >
    >
  >;
export type GetEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPostMutationBody =
  EnrichmentValuesRequest;
export type GetEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPostMutationError =
  HTTPValidationError;

/**
 * @summary Get Enrichment Values
 */
export const useGetEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof getEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost
          >
        >,
        TError,
        { subjectType: string; data: EnrichmentValuesRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof getEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPost
      >
    >,
    TError,
    { subjectType: string; data: EnrichmentValuesRequest },
    TContext
  > => {
    const mutationOptions =
      getGetEnrichmentValuesApiV1EntityLinksPickerEnrichmentSubjectTypeValuesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
